// extracted by mini-css-extract-plugin
export var straplineImageDetail = "strapline-image-detail-module--strapline-image-detail--e872a";